import { Box, Typography, SxProps } from '@mui/material'

const parametersComparisonTextBoxWrapper: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  minHeight: '40vh',
  textAlign: 'center',
  width: '60vw',
  maxWidth: '100%',
  mx: 'auto',
  px: 2,
  boxSizing: 'border-box',
  flex: 1,
}

const EmptyState = () => {
  return (
    <Box sx={parametersComparisonTextBoxWrapper}>
      <Typography variant="h6" color="text.secondary">
        There is no data to show
      </Typography>
    </Box>
  )
}

export default EmptyState
